import { BaseModel } from '../../_base/crud';
import { Shift } from './shift.model';

export class Machine extends BaseModel {
    id: number;
    create_uid: number;
    write_uid: number;
    write_date: any;
    create_date: any;
    name:string;
    iiot_code:string;
    company_id: number;
    machine_type_id: number;
    machine_type_name: string;
    machine_tech_type_id: number;
    machine_tech_type_name: string;
    product_type_id: number;
    product_type_name: string;
    product_package_units_name: string;
    vel_max: number;
    shifts: Shift[];
    data_conversion:number;
    pos:number;
    tons;
    Shifts: any[];
    clear(){
        this.id                     = undefined;
        this.create_uid             = undefined;
        this.write_date             = undefined;
        this.write_uid              = undefined;
        this.create_date            = undefined;
        this.company_id             = undefined;
        this.name                   = "";
        this.iiot_code              = "";
        this.machine_type_id        = undefined;
        this.machine_type_name      = "";
        this.machine_tech_type_id   = undefined;
        this.machine_tech_type_name = "";
        this.product_type_id        = undefined;
        this.product_type_name      = "";
        this.vel_max                = undefined;
        this.shifts                 = undefined;
        this.data_conversion        = undefined;
        this.pos                    = undefined;
        this.Shifts                 = [];
    }
}

export class MachineType extends BaseModel {
    id: number;
    name: string;
    clear(){
        this.id     = undefined;
        this.name   = "";
    }
}

export class MachineTechType extends BaseModel {
    id: number;
    name: string;
    clear(){
        this.id     = undefined;
        this.name   = "";
    }
}